import {
  CAR_DATA_MASTER_CREATE_YEARLY_PERCENTAGE_RATE_BEGIN,
  CAR_DATA_MASTER_CREATE_YEARLY_PERCENTAGE_RATE_SUCCESS,
  CAR_DATA_MASTER_CREATE_YEARLY_PERCENTAGE_RATE_FAILURE,
  CAR_DATA_MASTER_CREATE_YEARLY_PERCENTAGE_RATE_DISMISS_ERROR,
} from './constants';
import { BFFAgent } from 'BFFAgent';

export const createYearlyPercentageRate = () => async (dispatch)=> {
  try {
    dispatch({
      type:CAR_DATA_MASTER_CREATE_YEARLY_PERCENTAGE_RATE_BEGIN
    });
    await BFFAgent.Datamasters.createYearlyPercentageRate()
    dispatch({
      type: CAR_DATA_MASTER_CREATE_YEARLY_PERCENTAGE_RATE_SUCCESS,
    });
  } catch (error) {
    dispatch({
      type: CAR_DATA_MASTER_CREATE_YEARLY_PERCENTAGE_RATE_FAILURE,
      data: error
    });
  }
}

export const dismissCreateYearlyPercentageRateError = () => (dispatch) => {
  dispatch({
    type: CAR_DATA_MASTER_CREATE_YEARLY_PERCENTAGE_RATE_DISMISS_ERROR
  })
}


export const reducer = (state, action) => {
  switch(action.type){
    case CAR_DATA_MASTER_CREATE_YEARLY_PERCENTAGE_RATE_BEGIN:
      return {
        ...state,
        percentageRateCreatePending: true,
        percentageRateCreateError: false,
      };
    case CAR_DATA_MASTER_CREATE_YEARLY_PERCENTAGE_RATE_SUCCESS:
      return {
        ...state,
        percentageRateCreatePending: false,
        percentageRateCreateError: false,
      };
    case CAR_DATA_MASTER_CREATE_YEARLY_PERCENTAGE_RATE_FAILURE:
      return {
        ...state,
        percentageRateCreatePending: false,
        percentageRateCreateError: action.data
      };
    case CAR_DATA_MASTER_CREATE_YEARLY_PERCENTAGE_RATE_DISMISS_ERROR:
      return {
        ...state,
        percentageRateCreateError: null
      }
    default:
      return state;
  }
}